import { Menu } from 'primereact/menu';
import React, { useRef } from 'react';
import { ExternalLinkIcon } from 'smoothie';

import { logRocketSessionsUrl } from '../utils/LinkUtils';
import { Button } from './GroveButtons';

export const LogRocketSessionsMenu = ({ userId }: { userId: string }) => {
    const menu = useRef<Menu>(null);

    const menuItems: Array<{
        label: string;
        command: () => void;
    }> = [
        {
            label: 'iOS',
            command: () => {
                window.open(
                    logRocketSessionsUrl({
                        userId,
                        platform: 'ios',
                    }),
                    '_blank',
                );
            },
        },
        {
            label: 'Web',
            command: () => {
                window.open(
                    logRocketSessionsUrl({
                        userId,
                        platform: 'web',
                    }),
                    '_blank',
                );
            },
        },
    ];

    const toggleMenu = (event: React.SyntheticEvent) => {
        event.stopPropagation();
        menu.current?.toggle(event);
    };

    return (
        <>
            <Menu ref={menu} model={menuItems} popup popupAlignment="right" />
            <Button
                variant="secondary"
                size="small"
                icon={ExternalLinkIcon}
                iconPosition="right"
                onPress={toggleMenu}
            >
                LogRocket
            </Button>
        </>
    );
};
